export default "__VITE_ASSET__CtB0Ylla__"